export default {
    "name": "CheckoutCustomerAssociate",
    "kind": "HoudiniMutation",
    "hash": "6c329f1c81d9a77b8c76032080965b87a73682114c55224b28a204c28de208dc",

    "raw": `mutation CheckoutCustomerAssociate($checkoutId: ID!, $customerAccessToken: String!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  checkoutCustomerAssociateV2(
    checkoutId: $checkoutId
    customerAccessToken: $customerAccessToken
  ) {
    checkout {
      id
    }
    checkoutUserErrors {
      code
      field
      message
    }
    customer {
      id
    }
  }
}
`,

    "rootType": "Mutation",

    "selection": {
        "fields": {
            "checkoutCustomerAssociateV2": {
                "type": "CheckoutCustomerAssociateV2Payload",
                "keyRaw": "checkoutCustomerAssociateV2(checkoutId: $checkoutId, customerAccessToken: $customerAccessToken)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "checkout": {
                            "type": "Checkout",
                            "keyRaw": "checkout",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "checkoutUserErrors": {
                            "type": "CheckoutUserError",
                            "keyRaw": "checkoutUserErrors",

                            "selection": {
                                "fields": {
                                    "code": {
                                        "type": "CheckoutErrorCode",
                                        "keyRaw": "code",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "field": {
                                        "type": "String",
                                        "keyRaw": "field",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "message": {
                                        "type": "String",
                                        "keyRaw": "message",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "customer": {
                            "type": "Customer",
                            "keyRaw": "customer",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "checkoutId": "ID",
            "customerAccessToken": "String",
            "country": "CountryCode",
            "language": "LanguageCode"
        },

        "types": {}
    }
};

"HoudiniHash=19892844eb5bf82ab439da690c10f5c5e3bb856354415066496dd6f9fdc24244";